import { ApolloLink } from '@apollo/client'

import getLink from './http-link'

export default function apiServerLink(): ApolloLink {
  return getLink({ uri: process.env.NEXT_PUBLIC_WEB_BACK_SERVER_URL as string })
}
